( function( $ ) {
    'use strict';

    const $promoBanner = $( '.promo-banner-container[data-module="promo"]' );
    const $promoInner = $( '.promo-inner' );
    const $promoClose = $promoInner.find('span.close');
    const $stickyPromoBanner = $( '.promo-banner-sticky' );

    if ( !$stickyPromoBanner.length ) {
        /**
         * bail out early
         */
        return;
    }

    // define a function to set the top position of the element with the class ".promo-banner-sticky" to the height of the element with the class ".site-header"
    function setTopPosition() {
        const stickyDesktopNav = $( '.sticky-desktop-nav' );
        
        if ( !stickyDesktopNav.length ) {
            $stickyPromoBanner.css( 'top', '0px' );
        }
      
    }

    // // This functionality was requested to be disabled as per PS-16366
    // // Add a scroll event listener to the window
    // $(window).scroll(function() {
    //     // Check if the user has scrolled to the top of the page
    //     if ( $(this).scrollTop() === 0 ) {
    //         // Fade in the banner if it isn't already visible
    //         if ( $promoBanner.is( ':hidden' ) ) {
    //             $promoBanner.fadeIn();
    //         }
    //     }
    // });

    // call the function on document ready
    $(document).ready(setTopPosition);

    // call the function on window resize
    $(window).resize(setTopPosition);

    // fade out promo banner when close button is clicked
    $promoClose.on('click', function() {
        $promoBanner.fadeOut();
    });

} )( jQuery );
